
const config = {
  development: {
    API_CONTROL_URL: 'https://api.control.optibus.co',
    API_FACEID_URL: 'http://localhost:9000/api',
    ENVIRONMENT: 'development'
  },
  production: {
    API_CONTROL_URL: 'https://api.control.optibus.co',
    API_FACEID_URL: 'https://api.datik.ipanel.cloud/faceid/v2',
    ENVIRONMENT: 'production'
  }
};

// Get the current environment from environment variables or default to development
const currentEnv = process.env.REACT_APP_ENVIRONMENT || 'development';

// Export the configuration for the current environment
export default config[currentEnv];

// Also export all configs for reference
export { config };
